export default {
  "首页": "Trang chủ",
  "订单": "Đơn hàng",
  "新闻": "Tin tức",
  "个人中心": "Trung tâm cá nhân",
  "模拟账户": "Tài khoản mô phỏng",
  "可用资产": "Tài sản khả dụng",
  "入金": "Nạp tiền",
  "出金": "Rút tiền",
  "账单详情": "Chi tiết hóa đơn",
  "重置模拟账户": "Đặt lại tài khoản mô phỏng",
  "钱包": "Ví",
  "实名认证": "Xác thực danh tính",
  "邀请好友": "Mời bạn bè",
  "修改密码": "Thay đổi mật khẩu",
  "投诉邮箱": "Email khiếu nại",
  "其它": "Khác",
  "公告": "Thông báo",
  "语言": "Ngôn ngữ",
  "是否退出登录": "Bạn có chắc chắn muốn đăng xuất?",
  "复制": "Sao chép",
  "复制成功": "Sao chép thành công",
  "发送验证码成功": "Gửi mã xác minh thành công",
  "请输入密码": "Vui lòng nhập mật khẩu",
  "请再次输入密码": "Vui lòng nhập lại mật khẩu",
  "复制邀请链接": "Sao chép liên kết mời",
  "上传身份": "Vui lòng tải lên ảnh mặt trước và mặt sau của hộ chiếu/chứng minh thư",
  "正面": "Mặt trước",
  "上传正面": "Tải lên mặt trước của hộ chiếu/chứng minh thư",
  "反面": "Mặt sau",
  "上传反面": "Tải lên mặt sau của hộ chiếu/chứng minh thư",
  "完善信息": "Vui lòng hoàn thành thông tin cá nhân",
  "输入姓名": "Nhập tên của bạn",
  "身份证号": "Số hộ chiếu/CMND",
  "输入身份证号": "Vui lòng nhập số hộ chiếu/CMND",
  "收款货币": "Tiền tệ nhận",
  "银行名称": "Tên ngân hàng",
  "收款人账户": "Tài khoản người nhận",
  "货币": "Tiền tệ",
  "分店名称": "Tên chi nhánh",
  "绑定银行卡": "Liên kết thẻ ngân hàng",
  "银行地址": "Địa chỉ ngân hàng",
  "账号名称（假名）": "Tên tài khoản (biệt danh)",
  "绑定数字货币地址": "Liên kết địa chỉ tiền điện tử",
  "余额": "Số dư",
  "联系客服": "Liên hệ với bộ phận hỗ trợ",
  "行情": "Thị trường",
  "其他": "Khác",
  "设置": "Cài đặt",
  "收款人": "Người nhận",
  "添加": "Thêm",
  "确认": "Xác nhận",
  "取消": "Hủy bỏ",
  "钱包地址": "Địa chỉ ví",
  "请输入": "Vui lòng nhập",
  "退出登录": "Đăng xuất",
  "充值数量": "Số tiền nạp",
  "提交": "Gửi đi",
  "银行卡": "Thẻ ngân hàng",
  "选择网络": "Chọn mạng",
  "数字货币": "Tiền điện tử",
  "上传验证": "Tải lên xác minh",
  "提币地址": "Địa chỉ rút tiền",
  "数量(USD)": "Số lượng (USD)",
  "备注": "Ghi chú",
  "手续费": "Phí giao dịch",
  "预计到账数量": "Số tiền dự kiến nhận được",
  "暂无数据": "Không có dữ liệu",
  "入金记录": "Lịch sử nạp tiền",
  "提币记录": "Lịch sử rút tiền",
  "验证码": "Mã xác minh",
  "邀请码": "Mã mời",
  "提示": "Gợi ý",
  "请输入验证码": "Vui lòng nhập mã xác minh",
  "姓名": "Họ và tên",
  "邮箱登录": "Đăng nhập bằng email",
  "邮箱": "Email",
  "密码": "Mật khẩu",
  "新用户": "Người dùng mới",
  "立即加入": "Tham gia ngay",
  "忘记密码": "Quên mật khẩu",
  "登录": "Đăng nhập",
  "无需开户,立即创建模拟账号进行交易!": "Không cần mở tài khoản, tạo tài khoản mô phỏng ngay để giao dịch!",
  "电话": "Điện thoại",
  "再次输入密码": "Nhập lại mật khẩu",
  "职业": "Nghề nghiệp",
  "年收入": "Thu nhập hàng năm",
  "注册": "Đăng ký",
  "邮箱注册": "Đăng ký bằng email",
  "发送": "Gửi",
  "重置密码": "Đặt lại mật khẩu",
  "是否重置": "Bạn có chắc chắn muốn đặt lại mật khẩu?",
  "已重置": "Đã đặt lại",
  "名称": "Tên",
  "注册成功": "Đăng ký thành công",
  "加载中": "Đang tải",
  "您还未登录，请先登录": "Bạn chưa đăng nhập, vui lòng đăng nhập trước",
  "退出成功": "Đăng xuất thành công",
  "市价": "Giá thị trường",
  "挂单": "Đặt lệnh",
  "倍数": "Số lần",
  "止盈": "Chốt lời",
  "止损": "Cắt lỗ",
  "买入数量": "Số lượng mua",
  "每手": "Mỗi lệnh",
  "预估手续费": "Phí giao dịch ước tính",
  "预估保证金": "Ký quỹ ước tính",
  "买入": "Mua",
  "卖出": "Bán",
  "您的订单已确认": "Đơn hàng của bạn đã được xác nhận",
  "订单页面": "Trang đơn hàng",
  "盈亏": "Lãi lỗ",
  "当前保证金": "Ký quỹ hiện tại",
  "订单详情": "Chi tiết đơn hàng",
  "保证金": "Ký quỹ",
  "平仓": "Đóng lệnh",
  "修改": "Chỉnh sửa",
  "手数": "Số lot",
  "暂无数据": "Không có dữ liệu",
  "历史": "Lịch sử",
  "价格": "Giá",
  "请输入价格": "Vui lòng nhập giá",
  "手": "Lot",
  "搜索结果": "Kết quả tìm kiếm",
  "搜索产品": "Tìm sản phẩm",
  "持仓": "Vị thế",
  "语言": "Ngôn ngữ",
  "审核中": "Đang kiểm duyệt",
  "请上传证件照正/反面": "Vui lòng tải lên ảnh mặt trước và mặt sau của giấy tờ tùy thân",
  "上传成功": "Tải lên thành công",
  "上传失败": "Tải lên thất bại",
  "提交成功": "Gửi thành công",
  "删除": "Xóa",
  "删除成功": "Xóa thành công",
  "提币": "Rút tiền",
  "缺少参数或传值错误": "Thiếu tham số hoặc sai giá trị truyền",
  "操作成功": "Thao tác thành công",
  "充值金额": "Số tiền nạp",
  "类型": "Loại",
  "状态": "Trạng thái",
  "时间": "Thời gian",
  "单位": "Đơn vị",
  "最高价": "Giá cao nhất",
  "最低价": "Giá thấp nhất",
  "开盘价": "Giá mở cửa",
  "请注册或登录真实账号": "Vui lòng đăng ký hoặc đăng nhập tài khoản thực",
  "没有更多了": "Không còn dữ liệu",
  "提现金额": "Số tiền rút",
  "审核通过": "Duyệt thành công",
  "审核不通过": "Duyệt không thành công",
  "重新提交": "Gửi lại",
  "止盈价": "Giá chốt lời",
  "止损价": "Giá cắt lỗ",
  "总盈亏": "Lãi lỗ tổng cộng",
  "撤单": "Hủy đơn",
  "请先进行实名认证": "Vui lòng thực hiện xác thực danh tính trước",
  "产品列表": "Danh sách sản phẩm",
  "下单": "Đặt lệnh",
  "可用资金": "Vốn khả dụng",
  "欢迎登录": "Chào mừng đăng nhập",
  "可用": "Khả dụng",
  "冻结": "Đã đóng băng",
  "财务记录": "Bảng ghi chép tài chính",
  "交易对": "Cặp giao dịch",
  "开仓时间": "Thời gian mở vị thế",
  "收益": "Lợi nhuận",
  "操作": "Thao tác",
  "下单价": "Giá đặt lệnh",
  "当前价": "Giá hiện tại",
  "订单号": "Mã đơn hàng",
  "请选择": "Vui lòng chọn",
  "卖出(做空)止损价不能低于开仓价": "Giá Cắt Lỗ Bán (Short) Không Thể Thấp Hơn Giá Mở Lệnh",
  "卖出(做多)止盈价不能高于开仓价": "Giá Chốt Lãi Bán (Long) Không Thể Cao Hơn Giá Mở Lệnh",
  "买入(做多)止损价不能高于开仓价": "Giá Cắt Lỗ Mua (Long) Không Thể Cao Hơn Giá Mở Lệnh",
  "买入(做多)止盈价不能低于开仓价": "Giá Chốt Lãi Mua (Long) Không Thể Thấp Hơn Giá Mở Lệnh",
  "买入(做多)止盈价不能低于开仓价和现价": "Giá Chốt Lãi Mua (Long) Không Thể Thấp Hơn Giá Mở Lệnh và Giá Hiện Tại",
  "买入(做多)止损价不能高于开仓价和现价": "Giá Cắt Lỗ Mua (Long) Không Thể Cao Hơn Giá Mở Lệnh và Giá Hiện Tại",
  "卖出(做空)止损价不能低于开仓价和现价": "Giá Cắt Lỗ Bán (Short) Không Thể Thấp Hơn Giá Mở Lệnh và Giá Hiện Tại",
  "卖出(做多)止盈价不能高于开仓价和现价": "Giá Chốt Lãi Bán (Long) Không Thể Cao Hơn Giá Mở Lệnh và Giá Hiện Tại",

  "提现手续费": "Phí rút tiền",
  "提现退回": "Rút tiền và trả lại.",
  "系统加款": "Bổ sung hệ thống",
  "系统减款": "Giảm giá hệ thống",

  "交易周期": "Chu kỳ giao dịch",
  "秒": "Giây",
  "交易额": "Số tiền giao dịch",
  "买涨": "Mua với hy vọng giá tăng",
  "买跌": "Mua với hy vọng giá giảm",
  "秒数": "Số giây",
  "交易类型": "Loại giao dịch",
  "看涨": "Hy vọng giá tăng",
  "看跌": "Hy vọng giá giảm",
  "剩余时间": "Thời gian còn lại",
  "买入价": "Giá mua",
  "结算价": "Giá thanh toán",
  "交易额": "Số tiền giao dịch",
  "下单时间": "Thời gian đặt đơn",
  "结算时间": "Thời gian thanh toán",
  "该币种暂无交易": "Đồng tiền này chưa được giao dịch.",

  "总资产": "Tổng tài sản",
  "币种": "Đơn vị tiền tệ",
  "资产折合": "Chuyển đổi tài sản",
  "冻结金额": "Số tiền bị",
  "可用金额": "Số tiền có thể sử dụng",
  "公司资产": "Tài sản của công ty",
  "请输入旧密码": "Vui lòng nhập mật khẩu cũ",
  "请输入新密码": "Vui lòng nhập mật khẩu mới",
  "请再次输入新密码": "Vui lòng nhập lại mật khẩu mới",
  "白皮书": "Báo cáo trắng",
  "注册证书": "Chứng thư đăng ký",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "Quyền giải thích cuối cùng của các thông tin trên thuộc về bên quan hệ chính thức.",
  "上一页": "Trang trước",
  "下一页": "Trang tiếp",
  "关闭": "Đóng",
  "闪电兑换": "Đổi tiền nhanh",
  "全部": "Tất cả",
  "可用余额": "Số dư có thể sử dụng",
  "到": "Đến",
  "请输入数量": "Vui lòng nhập số lượng",
  "币种选择": "Chọn đơn vị tiền tệ",
  "从": "Từ",
  "兑换": "Đổi",
  "兑换成功！": "Đổi tiền thành công!",
  "支付": "Thanh toán",
  "全部兑换成功": "Tất cả các thao tác đổi tiền thành công",
  "获取": "Lấy",
  "数量": "số lượng",
  "拒绝原因": "Lý do từ chối",
  "交易密码": "Mật khẩu giao dịch",
  "设置交易密码": "Cài đặt mật khẩu giao dịch",
  "重置交易密码": "Đặt lại mật khẩu giao dịch",
  "确定": "Xác nhận",
  "是否购买？": "Mua không?",
  "外汇": "Ngoại hối",
  "期权": "Quyền chọn",
  "(用户中心)": "(Trung tâm người dùng)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Giao dịch của bạn đang được xử lý, vui lòng kiên nhẫn chờ giao dịch hoàn tất trước khi thực hiện các thao tác khác!",
  "继续下单": "Siparişi devam ettir",
  "交易方向": "Ticaret Yönü",
  "实现盈利": "Kar sağlamak",
  "最新价格": "Son fiyat",
  "结算完成": "Ödeme tamamlandı",
  "下单余额不足": "Số dư không đủ để đặt hàng",
  "输入交易额度": "Nhập số tiền giao dịch",
  "选择交易周期": "Chọn chu kỳ giao dịch",
  "审核拒绝": "Duyệt bị từ chối",
  "请输入正确的数量!": "Vui lòng nhập số lượng chính xác!",
  "上传身份": "Tải lên chứng minh thư",
  "上传正面": "Tải lên mặt trước",
  "上传反面": "Tải lên mặt sau",
  "完善信息": "Hoàn thiện thông tin",
  "输入姓名": "Nhập tên",
  "输入身份证号": "Nhập số CMND",
  "身份证号": "Số CMND",
  "请上传证件照正/反面": "Vui lòng tải lên ảnh chứng minh thư mặt trước/sau",
  "最小提现金额10USDT": "Số tiền rút tối thiểu là 10 USDT",
  "证件号码": "Số chứng minh nhân dân",
  "输入证件号码": "Nhập số chứng minh nhân dân",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Vui lòng tải lên chứng minh nhân dân, giấy phép lái xe hoặc hộ chiếu để xác minh danh tính!"



}
